module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets/fitsize//red_1.png?v=ce36645e";